// 图纸下载任务前端服务层：包装后端 /materialDrawing/download/job 相关接口
//
// 说明：后端 DrawingDownloadController 统一使用 EmResponseUtils.success(object)，
// 该方法实现为 `ResponseEntity.ok().body(object)`（未做 {code,message,data} 包装），
// 因此 HTTP 响应体就是业务数据本身，不需要额外剥一层 `.data`。
// 参见: mmf-backend/.../EmResponseUtils.java#success(T object)
//      mmf-backend/.../DrawingDownloadController.java#startJob/jobStatus
//
// store 的 api/post 解析为完整 axios response（需要 `.data` 取到响应体），
// api/get 解析为 response.data（响应体已经是最终结果，无需再取 `.data`）。
// 参见: src/store/api.js 的 get/post action 实现，
//      以及同域下 SithMomMaterialDrawingInfoList.vue 中
//      `dispatch('api/get', ...).then(response => { this.downloadRecords = response; })`
//      的既有用法（对接同一 EmResponseUtils.success 模式的接口，未做二次 `.data` 解包）。
const BASE = () => process.env.VUE_APP_SITHMES_II_URL + "/materialDrawing/download/job";

export function startJob(store, materials, scope) {
    return store.dispatch("api/post", {
        url: BASE(),
        data: {materials, scopeCode: scope},
    }, {root: true}).then(res => res.data);
}

export function pollStatus(store, jobCode) {
    return store.dispatch("api/get", {
        url: `${BASE()}/${jobCode}/status`,
        commonErrorHandle: false,
    }, {root: true});
}

// 触发异步打包：仅"下单"，后端立即返回，真正的打包在后台进行。
// 打包的成败由 pollStatus 的 jobStatusCode（PACKING → PACKED / PACK_FAILED）得知，
// 不再由这一次 HTTP 请求同步等待（同步等会被网关 30s 超时掐断）。接口幂等，可重复调用。
export function packJob(store, jobCode) {
    return store.dispatch("api/post", {url: `${BASE()}/${jobCode}/pack`, data: {}}, {root: true});
}

export function retryJob(store, jobCode) {
    return store.dispatch("api/post", {url: `${BASE()}/${jobCode}/retry`, data: {}}, {root: true});
}

export function cancelJob(store, jobCode) {
    return store.dispatch("api/post", {url: `${BASE()}/${jobCode}/cancel`, data: {}}, {root: true});
}
